import { useMutation } from '@tanstack/react-query';

export interface UploadStatementResult {
  merchantId: string;
  filename: string;
  key: string;
  url: string;
}

export function useUploadStatement() {
  return useMutation({
    mutationFn: async ({
      tenantId,
      month,
      year,
      file,
    }: {
      tenantId: string;
      month: number;
      year: number;
      file: File;
    }) => {
      const formData = new FormData();
      formData.append('file', file);
      const response = await fetch(`/api/v1/admin/statements/${tenantId}/upload?month=${month}&year=${year}`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({ error: { message: 'Upload failed' } }));
        throw error;
      }
      return response.json() as Promise<{ data: UploadStatementResult }>;
    },
  });
}
